import { getApiBase } from "../utils/apiBase";
/**
 * Simple SSE chat helper for report-writing agent.
 */

export interface ChatChunkEvent {
  type: 'chunk';
  chunk: string;
}
export interface ChatCompleteEvent {
  type: 'complete';
  answer: string;
  invalidate_queries?: unknown[];
}
export interface ChatTaskStartedEvent {
  type: 'task_started';
}
export interface ChatCloseEvent {
  type: 'close';
}
export interface ChatErrorEvent {
  type: 'error';
  error: string;
}

export type ChatSseEvent =
  | ChatChunkEvent
  | ChatCompleteEvent
  | ChatTaskStartedEvent
  | ChatCloseEvent
  | ChatErrorEvent;


interface StreamOptions {
  snapshotIds?: string[];
  threadId?: string;
}

export function streamReportChat(
  projectId: string,
  reportId: string,
  message: string,
  onEvent: (e: ChatSseEvent) => void,
  options?: StreamOptions,
): () => void {
  const params = new URLSearchParams({ message });
  options?.snapshotIds?.forEach((id) => {
    if (id) params.append('snapshot_id', id);
  });
  if (options?.threadId) {
    params.append('thread_id', options.threadId);
  }
  const url = `${getApiBase()}/api/projects/${projectId}/reports/${reportId}/chat?${params.toString()}`;

  const eventSource = new EventSource(url, { withCredentials: true });
  eventSource.onmessage = (ev) => {
    try {
      const data: ChatSseEvent = JSON.parse(ev.data);
      onEvent(data);
      if (data.type === 'close') eventSource.close();
    } catch {
      // ignore parse errors
    }
  };
  eventSource.onerror = () => {
    eventSource.close();
  };
  // return disposer
  return () => eventSource.close();
}
